import { RESELLER_GOOGLE_MAP_RECEIVE } from "../Actions/ResellerGoogleMap.action";
const defaultState = {
    resellerData: [] 
}
export const reseller = (state = defaultState, action) => {
    switch (action.type) {
    case RESELLER_GOOGLE_MAP_RECEIVE:
        return { 
            ...state, 
            resellerData: action.payload.reSellers.results,
            countries: action.payload.reSellers.countries,
            isGlobalChannel: action.payload.reSellers.isGlobalChannel,
        };
    default:
        return state;
    }
}
